import { createContext, type ReactNode, useContext } from "react";
import { useSound } from "./useSound";

type SoundController = ReturnType<typeof useSound>;
const SoundContext = createContext<SoundController | null>(null);

export function SoundProvider({ children }: { children: ReactNode }) {
  const sound = useSound();
  return <SoundContext.Provider value={sound}>{children}</SoundContext.Provider>;
}

export function useGlobalSound(): SoundController {
  const value = useContext(SoundContext);
  if (!value) throw new Error("useGlobalSound phải được dùng bên trong SoundProvider.");
  return value;
}
